import { useEffect } from "react";
import ReactGA from "react-ga4";

export default function Analytics() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.location.origin === "https://nauka.skumani.pl") {
        // Google Ads - GTAG
        ReactGA.initialize("AW-16922821276");

        // Hotjar
        const hotjarScript = document.createElement("script");
        hotjarScript.innerHTML = `
            (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:6367692,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `;
        document.head.appendChild(hotjarScript);
      }
    }
  }, []);

  return null;
}
